if (!customElements.get("mystery-gift")) {
  customElements.define(
    "mystery-gift",
    class MysteryGift extends HTMLElement {
      static #hasPrimary = false;
      #isPrimary = false;
      #fetchCart;
      #cartData;
      #existProduct;
      #dialogWrap;
      #nodes;
      #wrapper;
      #scrollTimeout;
      #mysteryTimeout;
      constructor() {
        super();
        this.#nodes = this.querySelectorAll(".mystery-gift__node");
        // 只让第一个注册为主组件
        if (!MysteryGift.#hasPrimary) {
          MysteryGift.#hasPrimary = true;
          this.#isPrimary = true;
        }
      }

      async connectedCallback() {
        if (!this.#isPrimary) return;
        document.addEventListener("cart:change", (event) => {
          console.log(event.detail.cart.items,8888)
          clearTimeout(this.#mysteryTimeout);
          // this.#mysteryTimeout = setTimeout(() => {
          //   this.mysteryGift()
          // }, 1300);
          console.time('cart update');
          requestAnimationFrame(() => {
            console.timeEnd('cart update');
            this.#mysteryTimeout = setTimeout(() => {
              this.mysteryGift()
            }, 500);
          });
          this.#fetchCart = event.detail["cart"];
        });
        window.addEventListener("pageshow", (event) => {
          setTimeout(() => {
            this.mysteryGift()
          }, 1000);
          // if (window.themeVariables.settings.pageType == "cart") {
          //   setTimeout(() => {
          //     this.mysteryGift()
          //   }, 1000);
          // }
        });
        document.querySelector('.new-cart-drawer').removeEventListener( 'click', this.handleDocumentClick);
        document.querySelector('.new-cart-drawer').addEventListener( 'click', this.handleDocumentClick);
      }
      handleDocumentClick(event) {
        const item = event.target.closest( '.cart-drawer__line-items .line-item' );
        if( !item ) return;
        const del = event.target.closest( '.cart-drawer__line-items .line-item .remove');
        const id = item.getAttribute('data-mystery-id');
        console.log(item, id,'id');
        console.log(id.length,'id');
        console.log(!id,'id');
        if (del && id) {
          console.log('remove click11');
          const cartDrawer = document.querySelector('.new-cart-drawer');
          cartDrawer.classList.add('form-disabled');
        }
      }
      mysteryGift() {
        const list = Array.from(document.querySelectorAll(".new-cart-drawer .cart-drawer__line-item-mystery")).map(item => {
          return {
            price: item.getAttribute("data-price"),
            id: item.getAttribute("data-product-id"),       // base product line item id
            handle: item.getAttribute("data-product-handle"), // base product handle
            giftId: item.getAttribute("data-mystery-id"),    // gift line item id
            giftHandle: item.getAttribute("data-mystery-handle"), // gift handle
            type: item.getAttribute("data-type"),
            href: item.getAttribute("data-href")
          };
        });
        // 已经完全匹配的情况
        const watches = list.filter(item => item.giftId && item.giftHandle);
        const gifts = list.filter(item => item.type === "Gift Card");
        // 1. 每个绑定礼物的手表，都有对应礼物
        const watchesMatched = watches.every(watch =>
          gifts.some(gift => gift.id === watch.giftId)
        );
        // 2. 每个神秘礼物，都有对应手表
        const giftsMatched = gifts.every(gift =>
          watches.some(watch => watch.giftId === gift.id)
        );
        const fullyMatched = watchesMatched && giftsMatched;
        console.log("完全匹配:", fullyMatched);
        const cartDrawer = document.querySelector('.new-cart-drawer')
        if(fullyMatched) {
          cartDrawer.classList.remove('form-disabled')
        } else {
          cartDrawer.classList.add('form-disabled')
        }
        
        document.querySelector('.new-cart-drawer').removeEventListener( 'click', this.handleDocumentClick);
        document.querySelector('.new-cart-drawer').addEventListener( 'click', this.handleDocumentClick);
        // dels.forEach((del) => {
        //   del.addEventListener('click', () => {
        //     console.log('click')
        //     document.querySelector('form[action="/cart"]').style.pointerEvents = 'none'
        //   })
        // })

        console.log(list,999)
        const cartIds = list.map(item => item.id);

        // Remove gifts if their base product is gone
        const giftIds = list.filter(item => item.type === "Gift Card");
        giftIds.forEach(v => {
          if(!list.find(item => item.giftId === v.id)) {
            console.log(`Removing gift with id ${v.id}`);
            const url = new URL(v.href, 'https://aa.host');
            fetch(`${Shopify.routes.root}cart/change.js`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                id: url.searchParams.get("id"),
                quantity: 0
              })
            })
            .then(response => response.json())
            .then(data => {
              document.dispatchEvent(new CustomEvent("cart:refresh"));
              const gift = document.querySelector(`.id-${v.id}`);
              if(gift) {
                gift.remove();
              }
              setTimeout(() => {
                const cartDrawer = document.querySelector('.new-cart-drawer')
                cartDrawer.classList.remove('form-disabled')
                console.log('remove(form-disabled)')
              }, 200);
            })
            .catch(error => {
              console.error('Error removing item from cart:', error);
            });
          }
        })

        // Add gifts if not already in cart
        list.forEach(product => {
          if (product.giftHandle) {
            const giftInCart = list.find(ci => ci.id === product.giftId);
            if (!giftInCart && cartIds.includes(product.id)) {
              Apex.queryProduct(product.giftHandle).then(giftProduct => {
                if (giftProduct?.variants?.length > 0) {
                  const variant = giftProduct.variants[0];
                  Apex.addProduct([{ id: variant.id, quantity: 1 }]).then(() => {
                    document.dispatchEvent(new CustomEvent("cart:refresh"));
                    const cartDrawer = document.querySelector('.new-cart-drawer')
                    cartDrawer.classList.remove('form-disabled')
                    console.log('remove(form-disabled)')
                  });
                }
              });
            }
          }
        });
      }
    }
  );
}
